<template>
  <div class="markdown prose w-full break-words dark:prose-invert light container">
    <hr>
    <h1 style="text-align: center">Chính sách Bảo mật cho ứng dụng aparking</h1>
    <h2>1. Giới thiệu</h2>
    <p>Chính sách bảo mật này mô tả cách chúng tôi thu thập, sử dụng và bảo vệ thông tin cá nhân của người dùng trong
      ứng dụng aparking của Trường Đại học Đồng Tháp. Chúng tôi cam kết bảo vệ thông tin cá nhân của bạn và tuân
      thủ các quyền pháp lý liên quan đến bảo mật dữ liệu.</p>
    <h2>2. Loại thông tin cá nhân được thu thập</h2>
    <p>Chúng tôi có thể thu thập các thông tin cá nhân sau đây:</p>
    <ul>
      <li>Tên và thông tin liên hệ (điện thoại, email) để xác định người dùng.</li>
      <li>Thông tin về tài khoản người dùng (nếu áp dụng).</li>
      <li>Dữ liệu về việc sử dụng ứng dụng và tương tác với nó, bao gồm dữ liệu như lịch sử tìm kiếm và tương tác với
        các tính năng.
      </li>
    </ul>
    <h2>3. Mục đích sử dụng thông tin cá nhân</h2>
    <p>Chúng tôi sử dụng thông tin cá nhân để:</p>
    <ul>
      <li>Cung cấp và duy trì dịch vụ trong ứng dụng aparking.</li>
      <li>Liên hệ và hỗ trợ người dùng.</li>
      <li>Cải thiện và phát triển ứng dụng.</li>
      <li>Tuân thủ các quyền pháp lý và quy định về bảo mật dữ liệu.</li>
    </ul>
    <h2>4. Bảo mật thông tin cá nhân</h2>
    <p>Chúng tôi đảm bảo sự bảo mật của thông tin cá nhân thông qua các biện pháp bảo mật vật lý, điện tử và quản lý phù
      hợp. Chúng tôi không chia sẻ thông tin cá nhân của bạn với bên thứ ba ngoại trừ trường hợp có sự đồng ý của bạn
      hoặc nếu cần thiết để tuân thủ các quy định pháp lý.</p>
    <h2>5. Quyền của người dùng</h2>
    <ul>
      <li>Bạn có quyền truy cập, chỉnh sửa và xóa thông tin cá nhân của mình trong ứng dụng.</li>
      <li>Bạn có quyền yêu cầu ngừng sử dụng thông tin cá nhân của bạn cho mục đích quảng cáo.</li>
      <li>Bạn có quyền yêu cầu sao chép hoặc chuyển dữ liệu cá nhân của bạn.</li>
    </ul>
    <h2>6. Liên hệ</h2>
    <p>Nếu bạn có bất kỳ câu hỏi hoặc phản ánh nào liên quan đến chính sách bảo mật này hoặc việc xử lý thông tin cá
      nhân, vui lòng liên hệ:</p>
    <p>
      <ul class="probootstrap-contact-info">
        <li><i class="icon-location2"></i><span>783, Phạm Hữu Lầu, P.6, Tp.Cao Lãnh, Đồng Tháp</span></li>
        <li><i class="icon-mail"></i><span>dhdt@dthu.edu.vn</span></li>
        <li><i class="icon-phone2"></i><span>0277 388 1518</span></li>
        <li><i class="icon-fax"></i><span>0277 388 1713</span></li>
        <li><i class="icon-facebook2"></i><span><a href="https://www.facebook.com/dongthapuni">https://www.facebook.com/dongthapuni</a></span></li>
      </ul>
    </p>
    <h2>7. Sửa đổi chính sách</h2>
    <p>Chúng tôi có quyền sửa đổi chính sách bảo mật này theo thời gian và sẽ thông báo cho người dùng qua ứng dụng hoặc
      trang web của trường.</p>
    <p>Chính sách này được áp dụng từ ngày 01/01/2023.</p>
    <hr>
  </div>

</template>

<script>
export default {
  data() {
    return {};
  },
}
</script>

<style scoped>

</style>
